import constants from '../constants';
import Listing from '../../models/Listing';

const initState = () => {
  return Listing();
};

const listing = (state = initState(), action = {}) => {
  const { payload, type } = action;

  if (type === constants.SET_CURRENT_LISTING) {
    return Listing(payload);
  } else {
    return state;
  }
};

export default listing;
